import { Skeleton, Typography } from '@mui/material';
import { Assessment } from '@schooly/api';
import React, { FC, useRef } from 'react';

import { ModalContent } from '../../../components/uikit-components/Modal/Modal.styled';
import { WithRef } from '../../../hooks/useWithRef';
import { MarkbookViewSettings } from '../Markbook/MarkbookSettings/MarkbookSettings';
import {
  AssessmentsPreviewEntriesTable,
  AssessmentsPreviewEntriesTableSkeleton,
} from './AssessmentsPreviewEntries/AssessmentsPreviewEntriesTable';

interface AssessmentsPreviewModalContentProps {
  assessment: Assessment;
  groupId: string;
  settings: MarkbookViewSettings;
}
export const AssessmentsPreviewModalContent: FC<AssessmentsPreviewModalContentProps> = ({
  assessment,
  groupId,
  settings,
}) => {
  const groupName = assessment?.groups.find((item) => item.id === groupId)?.name ?? '';
  const containerRef = useRef<HTMLDivElement>(null);

  const renderContent = () => {
    if (!groupId) {
      return (
        <>
          <Typography variant="h2" mb={3}>
            <Skeleton width={100} />
          </Typography>
          <AssessmentsPreviewEntriesTableSkeleton />
        </>
      );
    }

    return (
      <>
        <Typography variant="h2" mb={3}>
          {groupName}
        </Typography>
        <AssessmentsPreviewEntriesTable
          assessment={assessment}
          groupId={groupId}
          settings={settings}
        />
      </>
    );
  };

  return (
    <ModalContent ref={containerRef} sx={{ pb: 0 }}>
      <WithRef containerRef={containerRef}>{renderContent()}</WithRef>
    </ModalContent>
  );
};
